export default __webpack_public_path__ + "static/media/insta.7414ca60.png";